export const SEARCH_REPOSITORIES = "SEARCH::SEARCH_REPOSITORIES";
export const RESET_SEARCH = "SEARCH::RESET";
